/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
*/

import React from 'react';
import { DesignLayer } from '../types';
import { Trash2Icon } from './icons';

interface OutfitStackProps {
  history: DesignLayer[];
  onRemoveLast: () => void;
}

const OutfitStack: React.FC<OutfitStackProps> = ({ history, onRemoveLast }) => {
  if (history.length === 0) return null;

  const current = history[history.length - 1];

  return (
    <div className="bg-slate-50 p-4 rounded-xl border border-slate-200">
      <h2 className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-3">Đang xem</h2>
      
      <div className="flex items-start gap-3">
         <img 
            src={current.caseModel?.url} 
            alt="Case" 
            className="w-12 h-16 object-contain bg-white rounded-lg border border-slate-200 p-1 flex-shrink-0"
         />
         <div className="flex-1 min-w-0">
             <p className="font-medium text-slate-900 truncate text-sm">{current.caseModel?.name}</p>
             <p className="text-xs text-green-600 mt-1 flex items-center">
                 <span className="w-1.5 h-1.5 bg-green-500 rounded-full mr-1.5"></span>
                 Đã áp dụng thiết kế
             </p>
         </div>
         <button
            onClick={onRemoveLast}
            className="text-slate-400 hover:text-red-500 p-2 hover:bg-white rounded-lg transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center"
            title="Xóa thiết kế này"
         >
             <Trash2Icon className="w-4 h-4"/>
         </button>
      </div>
      
      <div className="mt-3 pt-3 border-t border-slate-200">
         <a 
            href={current.resultImage} 
            download={`case-design-${current.caseModel?.id}.png`}
            className="block w-full text-center bg-slate-700 text-white text-sm font-medium py-2.5 rounded-lg hover:bg-slate-800 transition-colors min-h-[44px] flex items-center justify-center"
         >
             Tải Ảnh Về
         </a>
      </div>
    </div>
  );
};

export default OutfitStack;